/** Maps hrefs the server suggests (search results, KPI tiles) to this app's routes. */
const RULES: [RegExp, (m: RegExpExecArray, title: string) => string][] = [
  [/^\/projects\/(?!all\b|stages\b|timeline\b|files\b|diary\b|photos\b)([^/?#]+)$/, (m) => `/projects/all/${m[1]}`],
  [/^\/site\/workers\/([^/?#]+)$/, (m) => `/office/workers?open=${m[1]}`],
  [/^\/site\/attendance$/, () => '/office/attendance'],
  [/^\/site\/?$/, () => '/office/attendance'],
  [/^\/stores\/items\/([^/?#]+)$/, (_m, title) => `/stores/stock?q=${encodeURIComponent(title)}`],
  [/^\/stores\/?$/, () => '/stores/stock'],
  [/^\/suppliers\/([^/?#]+)$/, (m) => `/buy/suppliers?open=${m[1]}`],
  [/^\/orders\/([^/?#]+)$/, (m) => `/buy/orders?open=${m[1]}`],
  [/^\/money\/bills\/([^/?#]+)$/, (m) => `/money/bills?open=${m[1]}`],
  [/^\/money\/invoices\/([^/?#]+)$/, () => '/money/invoices'],
];
export function toWebHref(href: string | undefined, title = ''): string | undefined {
  if (!href) return undefined;
  const path = href.replace(/^https?:\/\/[^/]+/, '');
  for (const [re, fn] of RULES) {
    const m = re.exec(path);
    if (m) return fn(m, title);
  }
  return path;
}

const KPI_HREF: Record<string, string> = {
  onsite: '/office/attendance',
  deliveries: '/stores/receive',
  water: '/stores/water',
  low: '/stores/stock',
  lowstock: '/stores/stock',
  approvals: '/approvals',
  over: '/money/budget',
  overbudget: '/money/budget',
  progress: '/projects/stages',
  snags: '/projects/diary?tab=snags',
  inspections: '/projects/diary?tab=inspections',
};
export function kpiHref(key: string, href?: string): string | undefined {
  return KPI_HREF[key] ?? toWebHref(href);
}
